// API Configuration
const API_BASE_URL = (process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000').replace(/\/+$/, '');

// API Endpoints
export const API_ENDPOINTS = {
    // Player endpoints
    ACTIVE_PLAYERS: `${API_BASE_URL}/tpe/players/active`,
    PLAYER_STATS: `${API_BASE_URL}/stats/players/base`,
    PLAYER_BATTING_STATS: `${API_BASE_URL}/stats/batting`,
    PLAYER_PITCHING_STATS: `${API_BASE_URL}/stats/pitching`,
    PLAYER_FIELDING_STATS: `${API_BASE_URL}/stats/fielding`,
    
    // Team endpoints
    ACTIVE_TEAMS: `${API_BASE_URL}/tpe/teams/active`,

    // Attribute endpoints
    ALL_ATTRIBUTES: `${API_BASE_URL}/players/attributes/all`,
    BATTER_ATTRIBUTES: `${API_BASE_URL}/players/attributes/batters`,
    PITCHER_ATTRIBUTES: `${API_BASE_URL}/players/attributes/pitchers`,

    // Paginated Attribute endpoints
    ALL_ATTRIBUTES_PAGINATED: `${API_BASE_URL}/players/attributes/all/paginated`,
    BATTER_ATTRIBUTES_PAGINATED: `${API_BASE_URL}/players/attributes/batters/paginated`,
    PITCHER_ATTRIBUTES_PAGINATED: `${API_BASE_URL}/players/attributes/pitchers/paginated`,

    // Future endpoints can be added here
    // PLAYER_FIELDING_STATS: `${API_BASE_URL}/stats/players/fielding`,
};

// Helper function to build query parameters
export const buildQueryParams = (params) => {
    const searchParams = new URLSearchParams();
    
    Object.entries(params).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== '') {
            searchParams.append(key, value);
        }
    });
    
    return searchParams.toString();
};

// Helper function to make API calls
export const apiCall = async (endpoint, options = {}) => {
    const defaultOptions = {
        headers: {
            'Content-Type': 'application/json',
        },
    };
    
    const response = await fetch(endpoint, { ...defaultOptions, ...options });
    
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return response.json();
};

export default API_ENDPOINTS; 